import { DEPARTMENT_TASK_CATEGORY } from "../actions/utilities";

const INITIAL_STATE = {
    getTaskCategoriesLoading: false,
    getTaskCategoriesSuccess: false,
    getTaskCategoriesFailure: false,
    getTaskCategoriesError: null,

    addTaskCategoryLoading: false,
    addTaskCategorySuccess: false,
    addTaskCategoryFailure: false,
    addTaskCategoryError: null,

    deleteTaskCategoryLoading: false,
    deleteTaskCategorySuccess: false,
    deleteTaskCategoryFailure: false,
    deleteTaskCategoryError: null,

    editTaskCategoryLoading: false,
    editTaskCategorySuccess: false,
    editTaskCategoryFailure: false,
    editTaskCategoryError: null,


    getTaskCategoriesSelectListLoading: false,
    getTaskCategoriesSelectListSuccess: false,
    getTaskCategoriesSelectListFailure: false,
    getTaskCategoriesSelectListError: null,

    TaskCategoriesList: [],
    TaskCategoriesSelectList: []
}

const departmentTaskCategoryReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case DEPARTMENT_TASK_CATEGORY.GET_CATEGORIES_REQUEST:
            return {
                ...state,
                getTaskCategoriesLoading: true,
                getTaskCategoriesSuccess: false,
                getTaskCategoriesFailure: false,
                getTaskCategoriesError: null,
            }
        case DEPARTMENT_TASK_CATEGORY.GET_CATEGORIES_SUCCESS:
            return {
                ...state,
                getTaskCategoriesLoading: false,
                getTaskCategoriesSuccess: true,
                getTaskCategoriesFailure: false,
                getTaskCategoriesError: null,
                TaskCategoriesList: action.payload
            }
        case DEPARTMENT_TASK_CATEGORY.GET_CATEGORIES_FAILURE:
            return {
                ...state,
                getTaskCategoriesLoading: false,
                getTaskCategoriesSuccess: false,
                getTaskCategoriesFailure: true,
                getTaskCategoriesError: action.payload,
                TaskCategoriesList: []
            }
        case DEPARTMENT_TASK_CATEGORY.ADD_CATEGORY_REQUEST:
            return {
                ...state,
                addTaskCategoryLoading: true,
                addTaskCategorySuccess: false,
                addTaskCategoryFailure: false,
                addTaskCategoryError: null,
            }
        case DEPARTMENT_TASK_CATEGORY.ADD_CATEGORY_SUCCESS:
            let cats = state.TaskCategoriesList;
            cats.push(action.payload);
            return {
                ...state,
                addTaskCategoryLoading: false,
                addTaskCategorySuccess: true,
                addTaskCategoryFailure: false,
                addTaskCategoryError: null,
                TaskCategoriesList: cats
            }
        case DEPARTMENT_TASK_CATEGORY.ADD_CATEGORY_FAILURE:
            return {
                ...state,
                addTaskCategoryLoading: false,
                addTaskCategorySuccess: false,
                addTaskCategoryFailure: true,
                addTaskCategoryError: action.payload,
            }
        case DEPARTMENT_TASK_CATEGORY.DELETE_CATEGORY_REQUEST:
            return {
                ...state,
                deleteTaskCategoryLoading: true,
                deleteTaskCategorySuccess: false,
                deleteTaskCategoryFailure: false,
                deleteTaskCategoryError: null,
            }
        case DEPARTMENT_TASK_CATEGORY.DELETE_CATEGORY_SUCCESS:
            // console.log('reducer =>', action.info);
            let cat_list = state.TaskCategoriesList.filter(c=>c.taskCategoryId!=action.info.taskCategoryId);
            state.TaskCategoriesList = cat_list;
            return {
                ...state,
                deleteTaskCategoryLoading: false,
                deleteTaskCategorySuccess: true,
                deleteTaskCategoryFailure: false,
                deleteTaskCategoryError: null,
            }
        case DEPARTMENT_TASK_CATEGORY.DELETE_CATEGORY_FAILURE:
            return {
                ...state,
                deleteTaskCategoryLoading: false,
                deleteTaskCategorySuccess: false,
                deleteTaskCategoryFailure: true,
                deleteTaskCategoryError: action.payload,
            }
        case DEPARTMENT_TASK_CATEGORY.EDIT_CATEGORY_REQUEST:
            return {
                ...state,
                editTaskCategoryLoading: true,
                editTaskCategorySuccess: false,
                editTaskCategoryFailure: false,
                editTaskCategoryError: null,
            }
        case DEPARTMENT_TASK_CATEGORY.EDIT_CATEGORY_SUCCESS:
            let tempDept = state.TaskCategoriesList;
            // console.log('action.payload', action.payload);
            // console.log('action.payload', tempDept);
            for (var x = 0; x < tempDept.length; x++) {
                if (tempDept[x].taskCategoryId == action.payload.taskCategoryId) {
                    tempDept[x] = action.payload;
                }
            }
            return {
                ...state,
                editTaskCategoryLoading: false,
                editTaskCategorySuccess: true,
                editTaskCategoryFailure: false,
                editTaskCategoryError: null,
                TaskCategoriesList: tempDept
            }
        case DEPARTMENT_TASK_CATEGORY.EDIT_CATEGORY_FAILURE:
            return {
                ...state,
                editTaskCategoryLoading: false,
                editTaskCategorySuccess: false,
                editTaskCategoryFailure: true,
                editTaskCategoryError: action.payload,
            }

        case DEPARTMENT_TASK_CATEGORY.GET_CATEGORIES_SELECTLIST_REQUEST:
            return {
                ...state,
                getTaskCategoriesSelectListLoading: true,
                getTaskCategoriesSelectListSuccess: false,
                getTaskCategoriesSelectListFailure: false,
                getTaskCategoriesSelectListError: null,
            }
        case DEPARTMENT_TASK_CATEGORY.GET_CATEGORIES_SELECTLIST_SUCCESS:
            return {
                ...state,
                getTaskCategoriesSelectListLoading: false,
                getTaskCategoriesSelectListSuccess: true,
                getTaskCategoriesSelectListFailure: false,
                getTaskCategoriesSelectListError: null,
                TaskCategoriesSelectList : action.payload
            }
        case DEPARTMENT_TASK_CATEGORY.GET_CATEGORIES_SELECTLIST_FAILURE:
            return {
                ...state,
                getTaskCategoriesSelectListLoading: false,
                getTaskCategoriesSelectListSuccess: false,
                getTaskCategoriesSelectListFailure: true,
                getTaskCategoriesSelectListError: action.payload,
                TaskCategoriesSelectList : []
            }

        default:
            return state;
    }
}

export { departmentTaskCategoryReducer };